import { Component, Inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiModule } from 'src/app/ui/ui.module';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IPriceBookViewDTO } from 'src/app/features/pricebook/models/pricebook.model';
import { PricebookService } from 'src/app/features/pricebook/services/pricebook.service';

@Component({
  selector: 'app-gift-banner-details',
  standalone: true,
  imports: [CommonModule, UiModule],
  templateUrl: './gift-banner-details.component.html',
  styleUrls: ['./gift-banner-details.component.scss']
})
export class GiftBannerDetailsComponent {
  gifts: IPriceBookViewDTO[] = [];
  amount: number | null = null;
  quantity: number | null = null;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { gifts: IPriceBookViewDTO[]; amount: number | null; quantity: number | null },
    private dialogRef: MatDialogRef<GiftBannerDetailsComponent>,
    private pricebookService: PricebookService,
  ) {
    this.gifts = data.gifts || [];
    this.amount = data.amount || null;
    this.quantity = data.quantity || null;
  }

  getGiftMessage(gift: IPriceBookViewDTO): { pricebook: string; message: string } {
    return this.pricebookService.getRewardMessage(gift, this.amount, this.quantity);
  }

  close() {
    this.dialogRef.close();
  }
}
